// extracted by mini-css-extract-plugin
export default {"container":"EZ-z","list":"FZ-z"};